<div class="preview-video-window">
  <ng-container *ngIf="!(source.localVideoObservable() | async)">
    <div class="avatar-window">
      <app-avatar-preview [profileType]="profileType" [url]="photoUrl"></app-avatar-preview>
    </div>
  </ng-container>

  <div #videoContainer [ngClass]="(source.localVideoObservable() | async) ? 'mine-video-window' : 'video-none'"></div>

  <ul class="actions preview-floating-controls">
    <li>
      <button
        class="control preview-control"
        id="preview-audio-button"
        [class.active]="source.localAudioObservable() | async"
        [disabled]="(source.previewErrorObservable() | async) !== null"
        (click)="toggleAudio()"
      >
        <lib-icon [type]="(source.localAudioObservable() | async) ? 'mic-white' : 'mic-off-white'"></lib-icon>
      </button>
    </li>

    <li>
      <button
        class="control preview-control"
        id="preview-video-button"
        [class.active]="source.localVideoObservable() | async"
        [disabled]="(source.previewErrorObservable() | async) !== null"
        (click)="toggleVideo()"
      >
        <lib-icon [type]="(source.localVideoObservable() | async) ? 'videocam-white' : 'videocam-off-white'"></lib-icon>
      </button>
    </li>
  </ul>

  <div class="preview-mic-level-badge">
    <div class="preview-mic-level">
      <div
        class="preview-mic-level-fill"
        [style.width.%]="((source.localMicVolumeObservable() | async) || 0) * 100"
      ></div>
    </div>
  </div>
</div>

<div class="preview-device-selectors">
  <div class="preview-device-selector">
    <label class="preview-device-label" id="preview-camera-label">
      {{ "video-calls.preview.select-camera" | translate }}
    </label>
    <div class="preview-device-dropdown" #cameraDropdown="libDropdown" libDropdown [hideByOutsideClick]="true">
      <button
        type="button"
        class="preview-device-dropdown-trigger"
        [class.open]="cameraDropdown.active$ | async"
        [disabled]="cameras.length <= 1"
        id="preview-camera-select"
        libDropdownToggle
        aria-labelledby="preview-camera-label"
      >
        <span class="preview-device-dropdown-value-wrapper">
          <lib-icon class="preview-device-dropdown-icon" type="videocam-white"></lib-icon>
          <span class="preview-device-dropdown-value">
            {{ getSelectedDeviceLabel(cameras, selectedCameraId, "video-calls.preview.select-camera") }}
          </span>
        </span>
        <lib-icon
          class="preview-device-dropdown-arrow"
          [class.open]="cameraDropdown.active$ | async"
          type="dropdown-arrow"
        ></lib-icon>
      </button>

      <ul class="preview-device-dropdown-panel" *libDropdownContent>
        <li
          *ngFor="let camera of cameras; let i = index"
          class="preview-device-dropdown-item"
          [class.selected]="camera.deviceId === selectedCameraId"
          (click)="onCameraSelect(camera); cameraDropdown.hideDropdown()"
        >
          <span class="preview-device-dropdown-item-check" *ngIf="camera.deviceId === selectedCameraId">✓</span>
          {{ getDeviceLabel(camera, i, "video-calls.preview.select-camera") }}
        </li>
      </ul>
    </div>
  </div>

  <div class="preview-device-selector">
    <label class="preview-device-label" id="preview-microphone-label">
      {{ "video-calls.preview.select-microphone" | translate }}
    </label>
    <div class="preview-device-dropdown" #microphoneDropdown="libDropdown" libDropdown [hideByOutsideClick]="true">
      <button
        type="button"
        class="preview-device-dropdown-trigger"
        [class.open]="microphoneDropdown.active$ | async"
        [disabled]="microphones.length <= 1"
        id="preview-microphone-select"
        libDropdownToggle
        aria-labelledby="preview-microphone-label"
      >
        <span class="preview-device-dropdown-value-wrapper">
          <lib-icon class="preview-device-dropdown-icon" type="mic-white"></lib-icon>
          <span class="preview-device-dropdown-value">
            {{ getSelectedDeviceLabel(microphones, selectedMicrophoneId, "video-calls.preview.select-microphone") }}
          </span>
        </span>
        <lib-icon
          class="preview-device-dropdown-arrow"
          [class.open]="microphoneDropdown.active$ | async"
          type="dropdown-arrow"
        ></lib-icon>
      </button>

      <ul class="preview-device-dropdown-panel" *libDropdownContent>
        <li
          *ngFor="let microphone of microphones; let i = index"
          class="preview-device-dropdown-item"
          [class.selected]="microphone.deviceId === selectedMicrophoneId"
          (click)="onMicrophoneSelect(microphone); microphoneDropdown.hideDropdown()"
        >
          <span class="preview-device-dropdown-item-check" *ngIf="microphone.deviceId === selectedMicrophoneId">✓</span>
          {{ getDeviceLabel(microphone, i, "video-calls.preview.select-microphone") }}
        </li>
      </ul>
    </div>
  </div>

  <div class="preview-device-selector">
    <label class="preview-device-label" id="preview-speaker-label">
      {{ "video-calls.preview.select-speaker" | translate }}
    </label>
    <div class="preview-device-dropdown" #speakerDropdown="libDropdown" libDropdown [hideByOutsideClick]="true">
      <button
        type="button"
        class="preview-device-dropdown-trigger"
        [class.open]="speakerDropdown.active$ | async"
        [disabled]="speakers.length <= 1"
        id="preview-speaker-select"
        libDropdownToggle
        aria-labelledby="preview-speaker-label"
      >
        <span class="preview-device-dropdown-value-wrapper">
          <lib-icon class="preview-device-dropdown-icon" type="speaker-white"></lib-icon>
          <span class="preview-device-dropdown-value">
            {{ getSelectedDeviceLabel(speakers, selectedSpeakerId, "video-calls.preview.select-speaker") }}
          </span>
        </span>
        <lib-icon
          class="preview-device-dropdown-arrow"
          [class.open]="speakerDropdown.active$ | async"
          type="dropdown-arrow"
        ></lib-icon>
      </button>

      <ul class="preview-device-dropdown-panel" *libDropdownContent>
        <li
          *ngFor="let speaker of speakers; let i = index"
          class="preview-device-dropdown-item"
          [class.selected]="speaker.deviceId === selectedSpeakerId"
          (click)="onSpeakerSelect(speaker); speakerDropdown.hideDropdown()"
        >
          <span class="preview-device-dropdown-item-check" *ngIf="speaker.deviceId === selectedSpeakerId">✓</span>
          {{ getDeviceLabel(speaker, i, "video-calls.preview.select-speaker") }}
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="preview-status" *ngIf="source.previewErrorObservable() | async as previewError">
  <div class="preview-status-content">
    <img class="preview-status-icon" src="/shared-assets/notifications/warning.svg" alt="" />
    <div class="preview-status-text">
      <span class="preview-status-title">{{ "video-calls.preview.errors.title" | translate }}</span>
      <span class="preview-status-message">{{ getPreviewErrorTranslationKey(previewError) | translate }}</span>
    </div>
  </div>
  <button libButton appearance="light-muted-outline" size="m" (click)="startPreview()">
    {{ "video-calls.preview.try-again" | translate }}
  </button>
</div>

<label class="preview-before-call-option" *ngIf="showPreviewBeforeCallOption">
  <input
    #previewBeforeCallCheckbox
    type="checkbox"
    id="preview-before-call-checkbox"
    [checked]="isPreviewBeforeCallEnabled"
    (change)="onPreviewBeforeCallChange(previewBeforeCallCheckbox.checked)"
  />
  {{ "video-calls.devices.show-preview-before-call" | translate }}
</label>
